<!-- eslint-disable -->
<template>
  <v-dialog v-model="dialog" max-width="400">
    <v-card>
      <v-card-title class="text-h5 d-flex align-center">
        <v-icon :color="iconColor" class="mr-2">{{ icon }}</v-icon>
        {{ title || $t('common.confirm') }}
      </v-card-title>

      <v-card-text class="pt-4">
        {{ message }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          variant="text"
          @click="cancel"
        >
          {{ cancelText || $t('common.cancel') }}
        </v-btn>
        <v-btn
          :color="confirmColor"
          variant="elevated"
          @click="confirm"
        >
          {{ confirmText || $t('common.ok') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
/* eslint-disable */
import { ref } from 'vue'

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  message: {
    type: String,
    required: true
  },
  confirmText: {
    type: String,
    default: ''
  },
  cancelText: {
    type: String,
    default: ''
  },
  confirmColor: {
    type: String,
    default: 'error'
  },
  icon: {
    type: String,
    default: 'mdi-alert-circle'
  },
  iconColor: {
    type: String,
    default: 'error'
  }
})

const emit = defineEmits(['confirm', 'cancel'])

const dialog = ref(false)

const open = () => {
  dialog.value = true
  return new Promise((resolve) => {
    const handleConfirm = () => {
      dialog.value = false
      resolve(true)
    }
    const handleCancel = () => {
      dialog.value = false
      resolve(false)
    }
    
    // Store handlers so we can use them
    window._confirmDialogResolve = resolve
  })
}

const confirm = () => {
  emit('confirm')
  if (window._confirmDialogResolve) {
    window._confirmDialogResolve(true)
    delete window._confirmDialogResolve
  }
  dialog.value = false
}

const cancel = () => {
  emit('cancel')
  if (window._confirmDialogResolve) {
    window._confirmDialogResolve(false)
    delete window._confirmDialogResolve
  }
  dialog.value = false
}

defineExpose({ open })
</script>

<style scoped>
</style>
